export const QUERY = {
  ALL_TENANTS: "ALL_TENANTS",
  TENANT_DETAILS: "TENANT_DETAILS",
  GOOGLE_AUTH: "GOOGLE_AUTH",
  GOOGLE_CALLBACK: "GOOGLE_CALLBACK",
  USER_DATA: "USER_DATA",
  VERIFY_EMAIL: "VERIFY_EMAIL",
  GET_MY_PROFILE: "GET_MY_PROFILE",
  GET_PROPERTY: "GET_PROPERTY",
  PROPERTIES_LIST: "PROPERTIES_LIST",
  GET_ALL_PROPERTIES: "GET_ALL_PROPERTIES",
  GET_ALL_DIRECTIONS: "GET_ALL_DIRECTIONS",
  GET_ALL_COLORS: "GET_ALL_COLORS",
  GET_ALL_FAMILY: "GET_ALL_FAMILY",
  GET_ALL_PROBLEMS: "GET_ALL_PROBLEMS",
  GET_ALL_FEEDBACKS: "GET_ALL_FEEDBACKS",
  GET_ALL_USERS: "GET_ALL_USERS",
  GET_ALL_PROPERTIES_LIST: "GET_ALL_PROPERTIES_LIST",
  GET_ALL_ROOMS: "GET_ALL_ROOMS",
  GET_ALL_OBJECTS: "GET_ALL_OBJECTS",
  GET_ALL_TOILETSEATS: "GET_ALL_TOILETSEATS",
  GET_REMEDY: "GET_REMEDY",
  GET_NOTIFICATION_PREFERENCES: "GET_NOTIFICATION_PREFERENCES",
  GET_VASTU_SELECTION: "GET_VASTU_SELECTION",
  CHECK_FEEDBACK_EXISTS: "CHECK_FEEDBACK_EXISTS",
  GET_ALL_SCOPE: "GET_ALL_SCOPE",
  CONTACT_MESSAGES: "CONTACT_MESSAGES",
  GET_MAP_STATE: "GET_MAP_STATE",
  GET_SITE_PLAN: "GET_SITE_PLAN",
};
